import {
  Component,
  Input,
  ViewChild,
  HostBinding,
  ChangeDetectorRef,
  AfterViewInit,
  HostListener,
  ElementRef
} from '@angular/core';


export type ButtonType = 'primary' | 'cancel' | 'delete' | 'confirm' | 'disabled' | 'clean';
export type ButtonSize = 'default' | 'icon' | 'large-icon' | 'menu';

/**
 * Render default button. Includes an slot between tags to add any string.
 *
 * Parameters
 * - **type**: 'primary' | 'cancel' | 'delete' | 'confirm' | 'disabled' | 'clean';
 * - **size**: 'default' | 'small' | 'icon' | 'large-icon' | 'menu';
 * - **buttonSubmit**: if true, the button will be of type 'submit'; else it's a normal 'button'
 * - **icon**: An icon from the `SVG` sprite
 *
 * ### Example
 *
 * ```
 *  <render-button
 *    #buttonName
 *    [type]="'primary'"
 *    [size]="'default'"
 *    [customClass]="'class'"
 *    [buttonSubmit]="false"
 *    [icon]="'check'" >
 *      <span>Button text</span>
 *   </render-button>
 * ```
 *
 */

@Component({
  selector: 'render-button',
  templateUrl: 'render-button.component.html',
  styleUrls: ['render-button.component.scss'],
  exportAs: 'render-button'
})

export class RenderButtonComponent implements AfterViewInit {

  @Input() public icon: string | undefined;
  @Input() public buttonSubmit: boolean = false;
  @Input() public loading: boolean = false;
  @Input() public type: ButtonType = 'primary';
  @Input() public size: ButtonSize = 'default';
  @Input() public customClass: string = '';

  @ViewChild('buttonText', { static: false }) public textNode!: ElementRef;

  public hasIconAndText: boolean = false;
  public hover: boolean = false;
  public ariaLabel: string = '';

  constructor(public cd: ChangeDetectorRef) {}

  @HostListener('mouseenter') public onMouseEnter(): void {
    this.hover = true;
  }

  @HostListener('mouseleave') public onMouseLeave(): void {
    this.hover = false;
  }

  @HostBinding('class')
  public get hostClasses(): string {
    return [
      this.type,
      this.size,
      this.customClass
    ].join(' ');
  }

  public ngAfterViewInit(): void {
    this.hasIconAndText = false;

    const { textContent } = this.textNode?.nativeElement as HTMLSpanElement;
    if (textContent?.trim() && this.icon) {
      if (this.size !== 'icon' && this.size !== 'large-icon' && this.size !== 'menu') {
        this.hasIconAndText = true;
      } else {
        this.ariaLabel = textContent.trim();
      }
      this.cd.detectChanges();
    }
  }

}
